import React, {useEffect, useState} from "react";
import {CommonUtil} from "../../utils/CommonUtil";
import BusyLoader from "../../Components/BusyLoader";
import {NetworkManager} from "../../Components/NetworkManager";
import ImageModal from "../../Components/ImageModal";
import {Constants} from "../Languages/Constants";

const ReservationProcessDamages = (props: any) => {
    const [equipImagesPath, setEquipImagesPath] = useState<any>([]);
    const [imageModalShow, setImageMoalShow] = useState(false);
    const [imageIdx, setImageIdx] = useState(0);
    const [gallary, setGallary] = useState<any>([]);
    const [modalTitle, setModalTile] = useState("");

    useEffect(() => {
        getEquipDamages();
    }, [props.equipData]);

    const getEquipDamages = () => {
      if (props.equipData?.attachments) {
        const attachments = Array.isArray(props.equipData.attachments) 
            ? props.equipData.attachments 
            : [props.equipData.attachments];
        
        const filteredDocs = attachments.filter((doc: any) => doc.documentType === CommonUtil.EQUIP_DAMAGES);

        if (filteredDocs.length > 0) {
          BusyLoader.showLoader();
          downloadAttachments(filteredDocs, 0, []);
        }
      }
    };

    const downloadAttachments = (docs: any[], index: number, collectedImages: any[]) => {
      if (index < docs.length) {
          const qParam = `objectPath=${docs[index].fullFilePath}`;
          NetworkManager.sendJsonRequest('api/session/downloadUrl', '', qParam, 'GET', false, (dataObj: any) => {
            const imgObj = {
                Path: dataObj,
                attachementId: docs[index].attachementId,
                Description: docs[index].attachmentDescription
            };
            downloadAttachments(docs, index + 1, [...collectedImages, imgObj]);
          }, () => {
            downloadAttachments(docs, index + 1, collectedImages);
          });
      } else {
          BusyLoader.hideLoader();
          setEquipImagesPath(collectedImages);
      }
    };

    const onCloseImagePopup = () => {
      setImageMoalShow(false);
    };

    const onClickDamageImage = (title: string, images: any[], imgPath: string, index: number) => {
      const formattedImages = images.length > 0 
          ? images.map((img: any) => ({
              original: img.Path,
              thumbnail: img.Path,
              comment: img.Description 
          }))
          : [{ original: imgPath, thumbnail: imgPath, comment: "" }];

      setModalTile(title);
      setGallary(formattedImages);
      setImageIdx(images.length > 0 ? index : 0);
      setImageMoalShow(true);
    };

    return (
        <>
          <ImageModal isOpen={imageModalShow} imageSrcs={gallary} caption={modalTitle} onClose={onCloseImagePopup} startIndex={imageIdx}/>
          <div className="container-fluid mb-5">
            <section>
              <div className="row"><div className="col-12"><h6 className="mb-4">Known Damages</h6></div></div>
              <div className="row g-2">
                {equipImagesPath.map((item: any, idx: number) => (
                  <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-6" key={idx}>
                    <div className="card h-100 shadow-sm border-1" role="button" 
                      onClick={() => onClickDamageImage(CommonUtil.getMessageText(Constants.DAMAGES, "Damages"), equipImagesPath, item.Path, idx)}>
                        <img 
                          src={item.Path} 
                          className="card-img-top" 
                          style={{ cursor: "pointer", height: "150px", objectFit: "cover" }}
                          alt={item.Description}
                        />
                        <div 
                          className="card-footer bg-white p-2 text-center" 
                          title={item.Description} 
                          style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        >
                          <span className="fw-bold">{item.Description}</span>
                        </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </>
    );
};

export default ReservationProcessDamages;